import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';

type RAlertVariant = 'warning' | 'info' | 'success';

interface RAlertProps {
    children: React.ReactNode;
    variant?: RAlertVariant;
}

const variantStyles: Record<RAlertVariant, { bg: string; border: string; text: string }> = {
    warning: { bg: Colors.lightTerraCotta, border: Colors.terraCotta, text: Colors.darkNavy },
    info: { bg: Colors.lightGrey, border: Colors.mediumNavy, text: Colors.darkNavy },
    success: { bg: Colors.lightTurq, border: Colors.turquoise, text: Colors.darkNavy },
};

export function RAlert({ children, variant = 'warning' }: RAlertProps) {
    const styles = variantStyles[variant];

    return (
        <Container style={{ backgroundColor: styles.bg, borderLeftColor: styles.border, color: styles.text }}>
            {children}
        </Container>
    );
}

const Container = styled('div')({
    padding: '10px 14px',
    borderRadius: 6,
    borderLeft: '4px solid',
    fontSize: 13,
    lineHeight: 1.4,
});
